import { Create } from 'react-admin';
import { PriceForm } from './Price.Form';

export const PriceCreate = () => {
    return (
        <Create redirect="list">
            <PriceForm />
        </Create>
    );
};
